import Swiper from "swiper";

const colorMarker = document.querySelector(".js-card-color-marker");

if (window.mobileMedia && colorMarker) {
    window.addEventListener("load", () => initColorMarkersSlider());
}

function initColorMarkersSlider() {
    new Swiper(".js-card-color-marker", {
        slidesPerView: "auto",
        spaceBetween: 16,
        centerSlidesBounds: true,
        watchOverflow: true,
    });
}
